import { html } from './template';

export const staffEmailRegex = /@cumulus\.care$/i;
export const appEmailRegex = /@registered-apps\.cumulus\.care$/i;
export const cumulusSupportLoginRegex = /^CumulusSupport/i;
export const cumulusSupportUserDescription = `This account belongs to a Cumulus support staff member. It is used to perform updates requested by customers.`;

export function staffLabel(email: string, classes?: string) {
  return email.match(staffEmailRegex) && !email.includes('+')
    ? html`<span class="Label Label--sponsors ${classes}">Staff</span>`
    : email.match(appEmailRegex)
      ? html`<span class="Label Label--attention ${classes}">App</span>`
      : null;
}
